<template>
    <div>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-button class="button_back" @click="goBack">
                    <ion-icon name="arrow-back-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>

        <div class="main_wrapper ion-padding">
            <div class="container">
                <PageTitle :title="pageText.pageTitle" :subtitle="pageText.formText" />

                <div class="invoice-list">
                    <div class="invoice-card" v-for="invoice in tableData.invoices" :key="invoice.id">
                        <div class="date-amount">
                            <div class="date">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 2V5" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16 2V5" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3.5 9.08984H20.5" stroke="rgb(var(--locumate-primary-color))"
                                        stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
                                        stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M15.6947 13.7002H15.7037" stroke="rgb(var(--locumate-primary-color))"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M15.6947 16.7002H15.7037" stroke="rgb(var(--locumate-primary-color))"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11.9955 13.7002H12.0045" stroke="rgb(var(--locumate-primary-color))"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11.9955 16.7002H12.0045" stroke="rgb(var(--locumate-primary-color))"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.29431 13.7002H8.30329" stroke="rgb(var(--locumate-primary-color))"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.29431 16.7002H8.30329" stroke="rgb(var(--locumate-primary-color))"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <span>{{ $moment(invoice.date, "YYYY/MM/DD").format("D MMM, YYYY") }}</span>
                            </div>
                            <div class="amount">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.67188 14.3298C8.67188 15.6198 9.66188 16.6598 10.8919 16.6598H13.4019C14.4719 16.6598 15.3419 15.7498 15.3419 14.6298C15.3419 13.4098 14.8119 12.9798 14.0219 12.6998L9.99187 11.2998C9.20187 11.0198 8.67188 10.5898 8.67188 9.36984C8.67188 8.24984 9.54187 7.33984 10.6119 7.33984H13.1219C14.3519 7.33984 15.3419 8.37984 15.3419 9.66984"
                                        stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12 6V18" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                        stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <span>
                                    <div>{{ formatCurrency(invoice.amount) }}</div>
                                    <div v-if="invoice.superAmount && isAustralia">{{
                                        formatCurrency(invoice.superAmount) }}</div>
                                </span>
                            </div>
                        </div>
                        <div class="d-flex flex-col">
                            <el-button class="save-button icon-button text-only"
                                @click="downloadPDF(invoice.id, false)">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.3 12.2305H17.82C16.84 12.2305 15.97 12.7705 15.53 13.6505L14.69 15.3105C14.49 15.7105 14.09 15.9605 13.65 15.9605H10.37C10.06 15.9605 9.62 15.8905 9.33 15.3105L8.49 13.6605C8.05 12.7905 7.17 12.2405 6.2 12.2405H2.7C2.31 12.2405 2 12.5505 2 12.9405V16.2005C2 19.8305 4.18 22.0005 7.82 22.0005H16.2C19.63 22.0005 21.74 20.1205 22 16.7805V12.9305C22 12.5505 21.69 12.2305 21.3 12.2305Z" fill="rgb(var(--locumate-primary-color))"/>
<path d="M12.75 2C12.75 1.59 12.41 1.25 12 1.25C11.59 1.25 11.25 1.59 11.25 2V4H12.75V2Z" fill="rgb(var(--locumate-primary-color))"/>
<path d="M22 9.81V10.85C21.78 10.77 21.54 10.73 21.3 10.73H17.82C16.27 10.73 14.88 11.59 14.19 12.97L13.44 14.45H10.58L9.83 12.98C9.14 11.59 7.75 10.73 6.2 10.73H2.7C2.46 10.73 2.22 10.77 2 10.85V9.81C2 6.17 4.17 4 7.81 4H11.25V7.19L10.53 6.47C10.24 6.18 9.76 6.18 9.47 6.47C9.18 6.76 9.18 7.24 9.47 7.53L11.47 9.53C11.48 9.54 11.49 9.54 11.49 9.55C11.56 9.61 11.63 9.66 11.71 9.69C11.81 9.73 11.9 9.75 12 9.75C12.1 9.75 12.19 9.73 12.28 9.69C12.37 9.66 12.46 9.6 12.53 9.53L14.53 7.53C14.82 7.24 14.82 6.76 14.53 6.47C14.24 6.18 13.76 6.18 13.47 6.47L12.75 7.19V4H16.19C19.83 4 22 6.17 22 9.81Z" fill="rgb(var(--locumate-primary-color))"/>
</svg>

                            </el-button>
                            <el-button v-if="invoice.superAmount && isAustralia"
                                class="save-button icon-button text-only ml-0" @click="downloadPDF(invoice.id, true)">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.3 12.2305H17.82C16.84 12.2305 15.97 12.7705 15.53 13.6505L14.69 15.3105C14.49 15.7105 14.09 15.9605 13.65 15.9605H10.37C10.06 15.9605 9.62 15.8905 9.33 15.3105L8.49 13.6605C8.05 12.7905 7.17 12.2405 6.2 12.2405H2.7C2.31 12.2405 2 12.5505 2 12.9405V16.2005C2 19.8305 4.18 22.0005 7.82 22.0005H16.2C19.63 22.0005 21.74 20.1205 22 16.7805V12.9305C22 12.5505 21.69 12.2305 21.3 12.2305Z" fill="rgb(var(--locumate-primary-color))"/>
<path d="M12.75 2C12.75 1.59 12.41 1.25 12 1.25C11.59 1.25 11.25 1.59 11.25 2V4H12.75V2Z" fill="rgb(var(--locumate-primary-color))"/>
<path d="M22 9.81V10.85C21.78 10.77 21.54 10.73 21.3 10.73H17.82C16.27 10.73 14.88 11.59 14.19 12.97L13.44 14.45H10.58L9.83 12.98C9.14 11.59 7.75 10.73 6.2 10.73H2.7C2.46 10.73 2.22 10.77 2 10.85V9.81C2 6.17 4.17 4 7.81 4H11.25V7.19L10.53 6.47C10.24 6.18 9.76 6.18 9.47 6.47C9.18 6.76 9.18 7.24 9.47 7.53L11.47 9.53C11.48 9.54 11.49 9.54 11.49 9.55C11.56 9.61 11.63 9.66 11.71 9.69C11.81 9.73 11.9 9.75 12 9.75C12.1 9.75 12.19 9.73 12.28 9.69C12.37 9.66 12.46 9.6 12.53 9.53L14.53 7.53C14.82 7.24 14.82 6.76 14.53 6.47C14.24 6.18 13.76 6.18 13.47 6.47L12.75 7.19V4H16.19C19.83 4 22 6.17 22 9.81Z" fill="rgb(var(--locumate-primary-color))"/>
</svg>

                            </el-button>
                        </div>
                        <div class="invoice-id">
                            Inv. Id : {{ invoice.invoiceNumber }}
                            <span v-if="invoice.superAmount && isAustralia">-S</span>
                            <span v-if="userRole == 'pharmacy'"> ({{ invoice.type }})</span>
                        </div>
                    </div>
                </div>
                <el-button class="load-more-button w-100" :disabled="disabled" @click="loadMore">LOAD MORE</el-button>

                <!-- <ElTable class="table centered-table" :data="tableData.invoices" :stripe="true" style="width: 100%">
                    
                    <ElTableColumn label="Invoice ID" width="170">
                        <template #default="scope">
                            <p>{{ scope.row.invoiceNumber }}</p>
                            <p v-if="scope.row.superAmount">{{ scope.row.invoiceNumber }}-S</p>
                            <p v-if="userRole == 'pharmacy'">{{ scope.row.type }}</p>
                        </template>
                    </ElTableColumn>
                    <ElTableColumn prop="date" label="Date" width="150">
                        <template #default="scope">
                            <p>{{ $moment(scope.row.date, "YYYY/MM/DD").format("D MMM, YYYY") }}</p>
                        </template>
                    </ElTableColumn>
                    <ElTableColumn prop="amount" label="Amount">
                        <template #default="scope">

                            <p>{{ formatCurrency(scope.row.amount) }}</p>
                            <p v-if="scope.row.superAmount">{{ formatCurrency(scope.row.superAmount) }}</p>
                        </template>
                    </ElTableColumn>
                    <ElTableColumn label="Action">
                        <template #default="scope">
                            <ion-button class="button_back" @click="downloadPDF(scope.row.id, false)">
                                <ion-icon name="download-outline"></ion-icon>
                            </ion-button>
                            <ion-button v-if="scope.row.superAmount" class="button_back"
                                @click="downloadPDF(scope.row.id, true)">
                                <ion-icon name="download-outline"></ion-icon>
                            </ion-button>
                        </template>
                    </ElTableColumn>
                </ElTable>
                <el-button class="load-more-button w-100" :disabled="disabled" @click="loadMore">LOAD MORE</el-button> -->
            </div>
        </div>
    </div>
</template>
<script>
import { instance as axios } from "@/hooks/axios/axios.js";
// import moment from "moment";
import {
    onMounted,
    // reactive,
    ref,
    inject
} from 'vue';
import { useStore } from "vuex";

import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { Capacitor } from '@capacitor/core';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline,
    downloadOutline,
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline,
    'download-outline': downloadOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useRouter,
} from 'vue-router'
import PageTitle from "@/components/PageTitle/PageTitle.vue";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        PageTitle
    },

    setup() {
        const $store = useStore();
        const $router = useRouter()
        const userRole = $store.getters.GET_USER_DATA.role;
        const $moment = inject(["$moment"]);
        console.log("🚀 ~ setup ~ $moment:", $moment)
        const isAustralia = isAustraliaRegion();

        const goBack = () => {
            $router.push({
                name: 'profile'
            })
        };
        let tableData = ref({ invoices: [] });

        const requestParams = {
            per_page: 10,
            page: 1,
        }

        let disabled = ref(false)

        const loadMore = async () => {
            requestParams.page += 1
            let invoices = await axios.get("billing/invoices", {
                params: requestParams
            })
            tableData.value.invoices = [...tableData.value.invoices, ...invoices.data.data]
            disabled.value = requestParams.page >= invoices.data.meta.lastPage
        }
        const fetchData = async () => {
            let invoices = await axios.get("billing/invoices", {
                params: requestParams
            })
            tableData.value.invoices = invoices.data.data
            disabled.value = requestParams.page >= invoices.data.meta.lastPage
        };
        const downloadPDF = async (id, isSuper) => {
            try {
                const response = await axios({
                    url: `/billing/invoices/${id}?super=${isSuper}`,
                    method: 'GET',
                    responseType: 'blob',
                });

                // Check if running on native mobile
                if (Capacitor.isNativePlatform()) {
                    const base64Data = await blobToBase64(response.data);
                    const fileName = `invoice_${id}${isSuper ? '_super' : ''}.pdf`;

                    // Save to device storage
                    const result = await Filesystem.writeFile({
                        path: fileName,
                        data: base64Data,
                        directory: Directory.Documents,
                        recursive: true
                    });

                    // Open the file
                    await Share.share({
                        title: 'Your Invoice',
                        url: result.uri,
                        dialogTitle: 'Open Invoice PDF'
                    });
                } else {
                    // Web browser handling
                    const url = window.URL.createObjectURL(response.data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `invoice_${id}.pdf`;
                    document.body.appendChild(link);
                    link.click();
                    setTimeout(() => {
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                    }, 100);
                }
            } catch (error) {
                console.error('Download failed:', error);
                // Add user notification here
            }
        };
        const blobToBase64 = (blob) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onerror = reject;
                reader.onload = () => {
                    resolve(reader.result.split(',')[1]);
                };
                reader.readAsDataURL(blob);
            });
        };

        const formatCurrency = (rate) => {
            return new Intl.NumberFormat("en-AU", {
                style: "currency",
                currency: "AUD",
            }).format(rate);
        };

        const pageText = {
            pageTitle: "Invoices",
            formText: "",
        };

        onMounted(() => {
            fetchData()
        });

        return {
            goBack,
            tableData,
            downloadPDF,
            loadMore,
            disabled,
            requestParams,
            formatCurrency,
            userRole,
            pageText,
            isAustralia,
            blobToBase64
        }
    },
}
</script>